module.exports = __webpack_public_path__ + "img/7_47.5c006d0a.png";